import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Carousel } from "primereact/carousel";

import InfiniteCarousel from "../components/InfiniteCarousel";
import Navegacao from "../components/Nav";
import NossosProdutos from "../components/NossosProdutos";
import Footer from "../components/Footer";
import Contato from "../components/Contato";
import QuemSomos from "../components/QuemSomos";

import imagem1 from "../assets/img/Carousel/RaioxManaus.png";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store/store";
import { useNavigate } from "react-router-dom";
import { useSessionExpirationCheck } from "../hooks/useSessionExpirationCheck";

import styles from "./Inicio.module.css";

interface Product {
  id: number;
  name: string;
  image: string;
  legenda?: string;
}

const Inicio = () => {
  const [products] = useState<Product[]>([
    { id: 1, name: "Produto 1", image: imagem1, legenda: "Raio-X Manaus" },
    { id: 2, name: "Produto 2", image: imagem1, legenda: "Tecnologia e precisão" },
    { id: 3, name: "Produto 3", image: imagem1, legenda: "Cuidado que você confia" },
  ]);

  const token = useSelector((state: RootState) => state.auth.token);
  const usuario = useSelector((state: RootState) => state.auth.user);
  const sessionExpiration = useSelector(
    (state: RootState) => state.auth.SessionExpiration
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useSessionExpirationCheck(sessionExpiration, token);

  const responsiveOptions = [
    { breakpoint: "1024px", numVisible: 1, numScroll: 1 },
    { breakpoint: "768px", numVisible: 1, numScroll: 1 },
    { breakpoint: "560px", numVisible: 1, numScroll: 1 },
  ];

  const productTemplate = (product: Product) => (
    <div className={styles.productItem} key={product.id}>
      <img
        src={product.image}
        loading="eager"
        className={styles.productImage}
        alt={product.legenda ?? product.name}
      />
      <div className={styles.overlay}>
        <span className={styles.overlayText}>{product.legenda}</span>
      </div>
    </div>
  );

  useEffect(() => {
    document.title = "Íkone | Página Inicial";
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div className={styles.wrapper}>
      <Navegacao token={token} user={usuario} />

      <section className={styles.heroSection}>
        <Carousel
          value={products}
          numVisible={1}
          numScroll={1}
          responsiveOptions={responsiveOptions}
          className={styles.carousel}
          circular
          autoplayInterval={4000}
          itemTemplate={productTemplate}
        />
      </section>

      <section className={`${styles.section} ${styles.sectionAlt}`}>
        <NossosProdutos />
      </section>

      <section className={styles.section}>
        <QuemSomos />
      </section>

      <InfiniteCarousel />

      <section className={`${styles.section} ${styles.sectionAlt}`}>
        <Contato />
      </section>

      <Footer />
    </div>
  );
};

export default Inicio;
